// Auto-generated by pipeline
export const firebaseConfig = {
  "authDomain": "holococriacao-ccf74.firebaseapp.com",
  "projectId": "holococriacao-ccf74",
  "storageBucket": "holococriacao-ccf74.appspot.com",
  "messagingSenderId": "290193460559",
  "appId": "1:290193460559:web:8ac23feec93938b32b893a",
  "measurementId": "G-4HHQEGEDY4",
  "apiKey": "AIzaSyA_FwrJaK7Iaa4aqV2UHGuducdM0DVOELk"
};
